module.exports = __webpack_public_path__ + "img/sun.3412ef13.svg";